import axios from 'axios';
import authHeader from './auth-header';

//const API_URL = 'http://localhost:8080/matrix-mlm/api/mlm/country/';
const API_URL = 'https://www.edibleherbsstores.com/api/mlm/country/';

class CountryService {
  getAll() {
    return axios.get(API_URL + `sorted`, { headers: authHeader() });
  }

  getAllPageable(name, page, pageSize) {
    return axios.get(API_URL + `all?name=${name}&page=${page}&size=${pageSize}`, { headers: authHeader() });
  }

  get(id) {
    return axios.get(API_URL + `one/${id}`, { headers: authHeader() });
  }

  create(country) {
    return axios.post(API_URL + `cre`, {
      code: country.code,
      name: country.name
    }, { headers: authHeader() });
  }

  update(id, country) {
    return axios.put(API_URL + `upd/${id}`, {
      code: country.code,
      name: country.name
    }, { headers: authHeader() });
  }

  delete(id) {
    return axios.delete(API_URL + `del/${id}`, { headers: authHeader() });
  }

  deleteAll() {
    return axios.delete(API_URL + `delall`, { headers: authHeader() });
  }

  getByName(name) {
    return axios.get(API_URL + `all?name=${name}`, { headers: authHeader() });
  }
}

export default new CountryService();